// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const Pause = ({ fill, svgComponents: { G, Path, Rect } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Rect height="31" rx="3.88" ry="3.88" width="11.63" x="23.88" y="4.5" />
            <Path d="M31.63,36H27.75a4.38,4.38,0,0,1-4.37-4.37V8.38A4.38,4.38,0,0,1,27.75,4h3.88A4.38,4.38,0,0,1,36,8.38V31.63A4.38,4.38,0,0,1,31.63,36ZM27.75,5a3.38,3.38,0,0,0-3.37,3.38V31.63A3.38,3.38,0,0,0,27.75,35h3.88A3.38,3.38,0,0,0,35,31.63V8.38A3.38,3.38,0,0,0,31.63,5Z" />
            <Rect height="31" rx="3.88" ry="3.88" width="11.63" x="4.5" y="4.5" />
            <Path d="M12.25,36H8.38A4.38,4.38,0,0,1,4,31.63V8.38A4.38,4.38,0,0,1,8.38,4h3.88a4.38,4.38,0,0,1,4.38,4.38V31.63A4.38,4.38,0,0,1,12.25,36ZM8.38,5A3.38,3.38,0,0,0,5,8.38V31.63A3.38,3.38,0,0,0,8.38,35h3.88a3.38,3.38,0,0,0,3.38-3.37V8.38A3.38,3.38,0,0,0,12.25,5Z" />
        </G>
    );
};

export default Pause;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/general/pause/index.js